import { useEffect, useMemo, useState } from "react";

import {
  InfoPanel,
  ArrowButton,
  Table, TableMetadata, useTable,
  Label, RadioGroup, Select,
  RadioButton, TextField, Modal,
  DocumentList, DocumentsModal, Button, DatePicker, TextArea, Typography,
} from "@king-ict/eupisi-ui/components";
import { CodeBook, UploadFile } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData, hrDate, getYearFromDate, hrDateWithTime } from "@king-ict/eupisi-ui/utils";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

import { getInstitutionById } from "../../api/Institution/InstitutionApi";
import {
  getRequest, getInitialQuestionnaire,
  getRequestDocument, approveRequest,
  getCommitteeDecisionList, getQuestionnaireExport,
  cancelRequest, revertRequest, changeRequestType,
  getDecisionProposal, getForm7, getEnrollmentDecision,
  getMedicalExamination, getCommittee, setEnrollmentInstitution
} from "../../api/Request/RequestApi";
import { useAppDispatch } from "../../app/store";
import {
    ContentArea, ToolbarTop,
    ToolbarEdit, FormCard, RequestHeader, InstitutionSelect
} from "../../components";
import { useAuth } from "../../hooks/auth/useAuth";
import {
  ValidationFailure, Role, SchoolYear, SaveResult
} from "../../models";
import {
    PersonDetails, Request, RequestStatus, CommercialProgram,
    RequestStep, RequestType, DocumentType,
    InstitutionChangeReason, CommitteeEnrollmentDecision, CommitteeDecision,
    DecisionProposal, Form7, EnrollmentDecision, MedicalExamination, RequestTypeChange
} from "../../models/Request";
import { ClaimType } from "../../models/User";
import { requestAdminDetailsUrl } from "../../routes/routes";
import { resetIsEdited, setIsEdited } from "../../slices/applicationSlice";

export function EnrollmentInstitutionEdit() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const auth = useAuth();

  const createDefault = (): Request => {
        return {
            id: 0,
            requestUID: "",
            code: "",
            statusId: RequestStatus.Draft,
            schoolYearId: 0,
            type: RequestType.RegularEnrollment,
            createdByAdmin: true,
            isOutsideEnrollmentArea: false,
            step: 0,
            subStep: 0,
        };
  };

  const [item, setItem] = useState<Request>(createDefault());
  const [enrollmentInstitutionId, setEnrollmentInstitutionId] = useState<number>(0);
  const [errors, setErrors] = useState<ValidationFailure[]>();

  useEffect(() => {
    (async () => {
      if (id && id !== "0") {
        var request = await getRequest(+id);
        if (request) {
          setItem(request);
          dispatch(setIsEdited())
        }
      }
    })();
  }, [id]);

  const handleEnrollmentInstitutionIdChange = (e: any) => {
    const val = Number.parseInt(e.target.value);
    setEnrollmentInstitutionId(val && !isNaN(val) ? val : 0);
  };
  return (
    <ContentArea>
        <ToolbarTop
            showAdd={"hide"}
            showBack={"show"}
            showEdit={"hide"}
            pageTitle={t("request.changeEnrollmentInstitution")}
            errors={errors}
        />
        <RequestHeader request={item} />
        <FormCard cardTitle={t("common.schoolCandidateModel.institutionList")}>
        <Row>
          <Col md={3}>
            {t("common.schoolCandidateModel.institutionList")}
          </Col>
          <Col md={9}>
            <InstitutionSelect
              label={t("common.schoolCandidateModel.institutionList")}
              name={"enrollmentInstitutionId"}
              //countyIds={auth.currentRole?.claimType === ClaimType.County ? auth.currentRole.locations : undefined}
              countyId={auth.currentRole?.role === Role.CAS || auth.currentRole?.role === Role.Helpdesk ? undefined : item.countyId}
              showUser={true}
              //excludeIds={[item.e]} // We should exclude the existing but it is not a property on the Request :(
              onChange={handleEnrollmentInstitutionIdChange}
              value={enrollmentInstitutionId !== 0 ? enrollmentInstitutionId : undefined}
            />
          </Col>
        </Row>
      </FormCard>
      <ToolbarEdit
        showCancel={"show"}
        showSave={enrollmentInstitutionId !== 0 ? "show" : "disable"}
        isEdited={true}
        onClickCancel={history.goBack}
        handleSave={async () => await setEnrollmentInstitution(item.id, enrollmentInstitutionId)}
        setSaveErrors={setErrors}
        redirectUrlSaveOK={() => requestAdminDetailsUrl(+id)}
        showCustom={false}
      />
    </ContentArea>
);

}
